import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { deleteSurvey } from '../../../../bridge';
import { __ } from '../../../../helpers/translations';

function DeleteSurveyButton({ survey, onDeleted }) {
  const [showModal, setShowModal] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const onClickDelete = async () => {
    setInProgress(true);
    await deleteSurvey(survey.surveyId);
    setShowModal(false);
    setInProgress(false);
    onDeleted();
  };

  return (
    <>
      <Button
        title={__('G136')}
        size="md"
        variant="light"
        onClick={() => setShowModal(true)}
        disabled={inProgress}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Button>
      <Modal show={showModal} centered onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>{__('G136')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {__('G137')}
          <br />
          <br />
          <strong>{__('G138')}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
            {__('G106')}
          </Button>
          <Button variant="danger" disabled={inProgress} onClick={onClickDelete}>
            {__('G107')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

DeleteSurveyButton.propTypes = {
  survey: PropTypes.shape({
    surveyId: PropTypes.string.isRequired,
  }),
  onDeleted: PropTypes.func,
};

export default DeleteSurveyButton;
